<template><div><h1 id="personenliste-nach-auftragsart" tabindex="-1"><a class="header-anchor" href="#personenliste-nach-auftragsart"><span>Personenliste nach Auftragsart</span></a></h1>
<p>Personenliste nach Auftragsart — Zeigt Aufträge nach Auftraggeber</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit Adressen, die Aufträge im angegebenen Zeitraum [von ErfassDatum - bis ErfassDatum] und für die angegebenen Auftragsarten erteilt haben. Die Liste wird sortiert nach Land - PLZ - Adressname. Es können entweder fakturierte oder noch nicht fakturierte Aufträge ausgewertet werden. Existieren für eine Adresse mehrere Aufträge, werden die Aufträge einzeln aufgeführt, d.h. die Adresse erscheint mehrmals im Output.</p>
<p>Pfad: <code v-pre>Verkauf → Auswertungen → Personenliste nach Auftragsart</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von ErfassDatum</dt>
<dd>Anfangsdatum, inklusive, Muss-Eingabe</dd>
<dt>bis ErfassDatum</dt>
<dd>Enddatum, inklusive, Muss-Eingabe</dd>
<dt>Auftragsarten</dt>
<dd>mit Kommas trennen, ! = ausschliessen, * = alle, Muss-Eingabe</dd>
<dt>Status</dt>
<dd>F = fakturiert, N = nicht fakturiert. Dabei liefert F vollständig und teilweise fakturierte Aufträge und N nur Aufträge, die gar keine fakturierte Position besitzen.</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>AdrNum</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Adressname</td>
</tr>
<tr>
<td>Strasse+Nr</td>
<td>Strasse und Nummer</td>
</tr>
<tr>
<td>PLZ</td>
<td>Postleitzahl</td>
</tr>
<tr>
<td>Ort</td>
<td>Ort</td>
</tr>
<tr>
<td>LiefDat</td>
<td>Lieferdatum (= Fakturadatum)</td>
</tr>
<tr>
<td>RG-Total</td>
<td>Rechnungstotal (inkl. Spende und Porto)</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                10.11.1997 15:34:42 pav  Seite     0</span>
<span class="line"> \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ </span>
<span class="line">AdrNum     Name                           Strasse+Nr                PLZ    Ort                LiefDat      RG-Total</span>
<span class="line">---------- ------------------------------ ------------------------- ------ ------------------ ---------- ----------</span>
<span class="line">821        Moris                          Montenachweg 3           3123   Belp                04.11.1997       3.00</span>
<span class="line">1,094      Platzer                        Frobenstrasse 72         4053   Basel               04.11.1997      50.00</span>
<span class="line">1,094      Platzer                        Frobenstrasse 72         4053   Basel               04.11.1997      25.00</span>
<span class="line">905,456    Amacher                        Grubenweg 3              4914   Roggwil BE          30.10.1997      25.00</span>
<span class="line">905,456    Amacher                        Grubenweg 3              4914   Roggwil BE          30.10.1997      50.00</span>
<span class="line"> \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ \_ </span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Kunde Moris in Belp hat per 4.11.97 einen Auftrag im Wert von Fr. 3.-- ausgeliefert erhalten.</p>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Spendeartikel werden in dieser Statistik mitgezählt.</p>
</div>
</div></template>


